const defaultState = () => ({
  blockForceOpen: false,
  source: null
})

export const state = defaultState()

export const mutations = {
  RESET_STATE (state) {
    Object.assign(state, defaultState())
  },
  SET_FORCE_OPEN (state, status) {
    state.blockForceOpen = status
  },
  SET_SOURCE (state, source) {
    state.source = source
  }
}
export const actions = {
  setSource ({ commit }, source) {
    commit('SET_SOURCE', source)
  },
  blockForceOpen ({ commit }, status) {
    commit('SET_FORCE_OPEN', status)
  }
}
